// @flow

// Note: those two import made the app crash. Why?
// So we save the account on the session and retrieve it.
// import RestaurantStore from 'stores/RestaurantStore';
// import ProAccountStore from '../stores/ProAccountStore';

// but this import works.. why?
// import SessionStore from 'stores/SessionStore';

import _ from 'lodash';
import { ProRole } from 'PMT/entities/security';
import { SessionUtils } from 'PMT/utils';

import {
  AdminPermissions,
  BookingPermissions,
  ExportPermissions,
  OrderSettingsPermissions,
  CartModifiersPermissions,
  ProAccountPermissions,
  RestaurantMenuPermissions,
  RestaurantSettingsPermissions
} from 'utils/permissions';

class SecurityContext {
  admin = new AdminPermissions();

  //
  // Roles for proRoles
  //

  proAccount = new ProAccountPermissions();

  //
  // Roles for booking
  //

  booking = new BookingPermissions();

  //
  // Restaurant Menu
  //

  restaurantMenu = new RestaurantMenuPermissions();

  //
  // Order
  //

  orderSettings = new OrderSettingsPermissions();

  cartModifiers = new CartModifiersPermissions();

  //
  // Restaurant settings
  //

  restaurantSettings = new RestaurantSettingsPermissions();

  export = new ExportPermissions();

  canEscaladePermission(permission: Function) {
    const allowed = [
      this.booking.canCancelBooking,
      this.booking.canCreateBookingOverLimit
    ];

    let res = false;

    _.each(allowed, (func) => {
      if (func === permission) {
        res = true;
        return false; // quit loop
      }
    });

    return res;
  }

  /**
   * @param permission The permission to check. Example: 'booking.canEdit..'
   * @param proRole The permission will be checked for the given proRole. If null, we retrieve the
   * proRole set on the session.
   */
  havePermission(permission: string, proRole: ProRole = null): boolean {
    let role:ProRole = null;

    if (_.isNull(proRole)) {
      /**
       * The role is attached to the account on ApiProAccount.getMeAccount()
       */
      const account = SessionUtils.getObjectFromSession('ACCOUNT');

      if (_.isNull(account)) {
        return false;
      }

      role = account.role;
    } else {
      role = proRole;
    }

    if (_.isNull(role) || _.isUndefined(role)) {
      return false;
    }

    try {
      const obj = permission.split('.').reduce((object, key) =>  {
        return object[key];
      }, role.permissions);

      /**
       * The permission is ok if the object equals true or is an object that contains child
       * permissions.
       */
      return !_.isUndefined(obj) && !_.isNull(obj) && obj !== false;
    } catch (e) {
      // do nothing
    }

    return false;
  }

}

const securityContextInstance = new SecurityContext();

export default securityContextInstance;



// WEBPACK FOOTER //
// ./scripts/utils/permissions/SecurityContext.js